<div class="container">
  <div class="row">
    <div class="col-9">
      <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
          <li class="breadcrumb-item">
            <a routerLink="/corporate/bu-segmentation">BU Segmentation Home</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            BU Attribute Update
          </li>
        </ol>
      </nav>
    </div>
    <div class="col-3">
      <div  style="justify-content: right">
        <input
          type="button"
          value="{{buselected}}"
          *ngIf="isWrite"
          class="custbtn red-lt-icon"
          routerLink="/corporate/selectbu-segmentation"
        />

      </div>
    </div>

  </div>

</div>

<div class="container">
  <form class="form-horizontal mt-1">
    <div class="row">
      <div class="col-md-10 col-xl-7">

        <div class="card mt-1">

          <div class="card-body">


            <div class="form-group" *ngIf="show">
              <label for="audList">Active Attributes List</label>
              <div class="piInnerList scroller" id="audList">
                <ul class="filtMain">
                  <li *ngFor="let item of attList">
                    <div class="row">
                      <div class="col-sm-9">
                        <label class="form-check-label">
                          {{item.field_name}}
                        </label>
                      </div>

                      <div class="col-sm-3">
                        <input  [checked]="attIds.indexOf(item.field_id)>=0"  type="checkbox"  (change)="selectAttribute($event, item.field_id)">
                      </div>

                    </div>

                  </li>
                </ul>
              </div>

            </div>
            <p *ngIf="!show">No Result Available</p>
          </div>
          <div class="card-footer text-center " *ngIf="show">
            <div class="my_class text-center">
              <button type="submit" class="custbtn" *ngIf="isWrite" (click)="updateAttribute()">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
